export default __webpack_public_path__ + "static/media/EyeballClosed.b737f72c.svg";